import React, { useState } from "react";

import {
  makeStyles,
  Card,
  CardContent,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  Paper,
  Typography,
} from "@material-ui/core";

import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import UpdateIcon from "@material-ui/icons/Update";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import { ReactComponent as SplitwiseIcon } from "../../assets/splitwise_icon.svg";
import { ReactComponent as VenmoIcon } from "../../assets/venmo_icon.svg";
import AddIcon from "@material-ui/icons/Add";

import clsx from "clsx";

import Toggle from "../../components/Toggle";

import { formatPrice } from "../../util";

import CheckoutForm from "./Form";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  infoSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  cardContainer: {
    margin: theme.spacing(3),
  },
  paragraph: {
    marginTop: theme.spacing(2),
  },
  formContainer: {
    maxWidth: 400,
  },
}));

export default () => {
  const classes = useStyles();
  const periodOptions = ["annual", "monthly"];
  const [selectedPeriod, setSelectedPeriod] = useState(periodOptions[0]);
  const [selectedPlan, setSelectedPlan] = useState("pro");
  return (
    <Paper className={classes.root}>
      <div className={classes.infoSection}>
        <Toggle
          options={periodOptions}
          selected={selectedPeriod}
          onSelect={(o) => setSelectedPeriod(o)}
        />
        <Typography variant="body1" className={classes.paragraph}>
          {selectedPeriod === periodOptions[0]
            ? `You're getting two months free by choosing an Annual plan!`
            : `Upgrade to annual pricing to get two free months.`}
        </Typography>

        <Grid container spacing={3} className={classes.cardContainer}>
          <PlanCard
            type="standard"
            features={["1 account", "test"]}
            onSelect={() => setSelectedPlan("standard")}
            selected={selectedPlan === "standard"}
          />
          <PlanCard
            type="pro"
            monthlyPrice={selectedPeriod === "annual" ? 50 / 12 : 5}
            numAccounts={5}
            onSelect={() => setSelectedPlan("pro")}
            selected={selectedPlan === "pro"}
          >
            <ListItem>
              <ListItemIcon>
                <HourglassEmptyIcon />
              </ListItemIcon>
              Pending transactions
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <UpdateIcon />
              </ListItemIcon>
              Recurring transactions
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <AddIcon />
              </ListItemIcon>
              All future features
            </ListItem>
          </PlanCard>
        </Grid>
      </div>
      <div className={classes.formContainer}>
        <CheckoutForm period={selectedPeriod} />
        <p>
          {selectedPeriod === periodOptions[0]
            ? `Your card will be charged $50.00 yearly.`
            : `Your card will be charged $5.00 monthly.`}
        </p>
      </div>
    </Paper>
  );
};

const useCardStyles = makeStyles((theme) => ({
  card: {
    borderRadius: 10,
    borderStyle: "solid",
    borderWidth: 3,
    borderColor: "#00000000",
    cursor: "pointer",
    height: "100%",
  },
  selected: {
    borderColor: theme.palette.primary.light,
  },
  selectedIcon: {
    color: theme.palette.primary.main,
  },
  price: {
    fontSize: "1.5rem",
  },
}));

const PlanCard = ({
  type,
  monthlyPrice,
  numAccounts = 1,
  selected,
  onSelect,
  children,
}) => {
  const classes = useCardStyles();
  return (
    <Grid item xs={12} sm={6}>
      <div
        onClick={onSelect}
        className={clsx(classes.card, selected && classes.selected)}
      >
        <CardContent>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ paddingRight: 10 }}>
              {selected ? (
                <CheckCircleIcon className={classes.selectedIcon} />
              ) : (
                <RadioButtonUncheckedIcon />
              )}
            </div>
            <Typography
              variant="h5"
              style={{ textTransform: "capitalize", fontWeight: 600 }}
            >
              {type}
            </Typography>
          </div>
          <p style={{ textAlign: "center", marginTop: 20 }}>
            <span className={classes.price}>
              {monthlyPrice ? formatPrice(monthlyPrice) : "Free"}
            </span>
            {monthlyPrice && <span className={classes.interval}>/ month</span>}
          </p>
          <List>
            <ListItem>
              <ListItemIcon>
                <AccountBalanceIcon />
              </ListItemIcon>
              {numAccounts} accounts
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <SplitwiseIcon height={22} />
              </ListItemIcon>
              Send to Splitwise
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <VenmoIcon height={22} />
              </ListItemIcon>
              Send to Venmo
            </ListItem>
            {children}
          </List>
        </CardContent>
      </div>
    </Grid>
  );
};
